import React, { Component } from "react";
import moment from "moment";
import { Spin } from "antd";
// 组件
import NoData from "@/components/common/no_data";
// 接口以及调用接口方法
import { intacttrend } from "@/fetch/fetchApi";
import fetchHandler from "@/fetch/fetchHandler";
// icon
import Echarts from "echarts";
// 图片
import legend1 from "@/assets/img/displayBoard/whl.svg";
import legend2 from "@/assets/img/displayBoard/lxl.svg";
import legend3 from "@/assets/img/displayBoard/gzl.svg";
// 国际化切换语言
import { connect } from "react-redux";
import { injectIntl } from "react-intl";

@connect((state) => state)
class StubIntactLine extends Component {
  constructor(props) {
    super(props);
    this.props = props;
    this.chartId = this.props.chartId ? this.props.chartId : ""; // 设置 完好率ID
    this.state = {
      showSping: true, // loading加载是否显示：true，显示，false，不显示
      noData: false, // 是否有数据
      param: {
        cityIds: this.props.param.cityIds,
        provinceIds: this.props.param.provinceIds, // 默认 000000全国
        date: this.props.param.date,
        operationProperty: this.props.param.operationProperty,
        operationMode: this.props.param.operationMode,
      },
      lineData: [],
    };
  }

  // 父组件修改param时执行
  componentWillReceiveProps(nextProps) {
    if (
      nextProps.param.provinceIds === this.state.param.provinceIds
      && nextProps.param.cityIds === this.state.param.cityIds
      && nextProps.param.operationProperty === this.state.param.operationProperty
      && nextProps.param.operationMode === this.state.param.operationMode
      && nextProps.param.date === this.state.param.date
    ) {
      console.log("设备状态一样");
    } else {
      console.log("设备状态不一样");

      this.setState(
        {
          showSping: true,
          param: {
            cityIds: nextProps.param.cityIds,
            provinceIds: nextProps.param.provinceIds, // 默认 000000全国
            date: nextProps.param.date,
            operationProperty: nextProps.param.operationProperty,
            operationMode: nextProps.param.operationMode,
          },
        },
        () => {
          this.getIntactRate();
        },
      );
    }
  }

  componentDidMount() {
    this.getIntactRate();
    // 监听window resize方法
  }

  // 获取数据
  getIntactRate() {
    // 获取成功率趋势数据
    fetchHandler(intacttrend, {
      startTime: this.state.param.date,
      cityIds: this.state.param.cityIds,
      operationMode: this.state.param.operationMode,
      operationProperty: this.state.param.operationProperty,
      provinceIds: this.state.param.provinceIds,
    }).then((res) => {
      console.log(res);
      if (res.data) {
        this.setState(
          {
            lineData: [...res.data],
            showSping: false,
            noData: !res.data.length > 0,
          },
          () => {
            this.renderChart();
          },
        );
      }
    });
  }

  // 秒转换
  handleSecord(value) {
    const day = Math.floor(value / (24 * 3600)); // Math.floor()向下取整
    const hour = Math.floor((value - day * 24 * 3600) / 3600);
    const minute = Math.floor((value - day * 24 * 3600 - hour * 3600) / 60);
    const second = value - day * 24 * 3600 - hour * 3600 - minute * 60;
    if (day > 0) {
      return `${day}天${hour}时${minute}分${second}秒`;
    } else if (hour > 0) {
      return `${hour}时${minute}分${second}秒`;
    } else if (minute > 0) {
      return `${minute}分${second}秒`;
    } else {
      return `${second}秒`;
    }
  }

  renderChart() {
    window.removeEventListener("resize", () => {});
    const { lineData } = this.state;
    // 数据
    const xAxisData = []; // X轴
    const intactData = []; // 完好率
    const offlineData = []; // 离线率
    const errorData = []; // 故障率

    // 折线图数据设置
    lineData.map((item) => {
      xAxisData.push(moment(item.date).format("MM.DD"));
      intactData.push({
        value: item.intactRate,
        info: {
          averageOperationDuration: item.averageOperationDuration,
        },
      });
      offlineData.push({
        value: item.offlineRate,
        info: {
          averageOfflineDuration: item.averageOfflineDuration,
        },
      });
      errorData.push({
        value: item.errorRate,
        info: {
          averageErrorDuration: item.averageErrorDuration,
        },
      });
      return false;
    });

    const myChart = Echarts.init(document.getElementById("stubIntactLine"));
    const option = {
      tooltip: {
        trigger: "axis",
        axisPointer: {
          type: "cross",
          crossStyle: {
            color: "#999",
          },
        },
        backgroundColor: "rgba(0,0,0,.5)",
        show: true,
        formatter: (params) => {
          let str = "";
          if (params[0].axisValue) {
            str += `<div  style="padding:10px 24px 3px 10px;font-size:14px">${params[0].axisValue}</div>`;
            str += `<div  style="padding:3px 24px 3px 10px;font-size:14px">平均完好时长：${this.handleSecord(
              params[0].data.info.averageOperationDuration,
            )}，完好率：${params[0].data.value}%</div>`;
            str += `<div  style="padding:3px 24px 3px 10px;font-size:14px">平均离线时长：${this.handleSecord(
              params[1].data.info.averageOfflineDuration,
            )}，离线率：${params[1].data.value}%</div>`;
            str += `<div  style="padding:3px 24px 12px 10px;font-size:14px">平均故障时长：${this.handleSecord(
              params[2].data.info.averageErrorDuration,
            )}，故障率：${params[2].data.value}%</div>`;
            return str;
          }
        },
        position: function (pos, params, dom, rect, size) {
          // 鼠标在左侧时 tooltip 显示到右侧，鼠标在右侧时 tooltip 显示到左侧。
          const obj = { top: 60 };
          obj[["left", "right"][+(pos[0] < size.viewSize[0] / 2)]] = 5;
          return obj;
        },
      },
      color: ["#75DDB2", "#919191", "#EB7F66", "#EB7F66"],
      legend: {
        textStyle: {
          padding: [10, 0],
        },
        itemGap: 15,
        itemWidth: 21,
        itemHeight: 8,
        data: [
          {
            name: "完好率",
            icon: `image://${legend1}`,
          },
          {
            name: "离线率",
            icon: `image://${legend2}`,
          },
          {
            name: "故障率",
            icon: `image://${legend3}`,
          },
        ],
        top: 0,
      },
      xAxis: [
        {
          type: "category",
          data: xAxisData,
          axisTick: {
            alignWithLabel: true,
            color: "#C4C6CF",
          },
          axisLine: {
            lineStyle: {
              color: "#C4C6CF",
            },
          },
          axisLabel: {
            interval: 0,
            margin: 10,
            textStyle: {
              color: "#666666",
            },
          },
        },
      ],
      yAxis: [
        {
          type: "value",
          name: "",
          min: 0,
          max: 100,
          interval: 10,
          axisLine: { show: false },
          axisTick: { show: false },
          axisLabel: {
            textStyle: {
              color: "#666666",
            },
            formatter: "{value} %",
          },
        },
      ],
      grid: {
        left: "50px",
        right: "0px",
        bottom: "20px",
      },
      series: [
        {
          name: "完好率",
          type: "line",
          yAxisIndex: 0,
          data: intactData,
          symbolSize: 1,
          showSymbol: false,
          smooth: true,
        },
        {
          name: "离线率",
          type: "line",
          yAxisIndex: 0,
          data: offlineData,
          symbolSize: 1,
          showSymbol: false,
          smooth: true,
        },
        {
          name: "故障率",
          type: "line",
          yAxisIndex: 0,
          data: errorData,
          symbolSize: 1,
          showSymbol: false,
          smooth: true,
        },
      ],
    };
    myChart.clear();
    myChart.setOption(option);

    window.addEventListener("resize", () => {
      if (this.props.panelsInfo.activeKey === "0001") {
        myChart.resize();
      }
    });
  }

  render() {
    const content = (
      <Spin tip="加载中..." spinning={this.state.showSping}>
        <div className="exception-line-chart">
          <div className="line" id="stubIntactLine"></div>
        </div>
        {this.state.noData ? (
          <div className="no_data_com no_data_line">
            <NoData />
          </div>
        ) : null}
      </Spin>
    );

    return content;
  }
}

export default injectIntl(StubIntactLine);



// WEBPACK FOOTER //
// ./src/AntD/pages/displayBoard/stubIntactLine.js